// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"828a64516009eea4","5763":"7f82c11b1e9243fb","6893":"949de0bcbaf8667f","6974":"366524c6bcde5460","7222":"5178bef0690dac16","7937":"3efcf0d55f827322"}[chunkId] + ".js";
};